export const tr = {
    access: 'Erişim yetkileri',
    cancel: 'İptal',
    save: 'Kaydet'
};
